import api from "@/api";
export default class Currency {
  constructor(rawdata = {}) {
    this.name = rawdata.name ? rawdata.name : "";
    this.rate = rawdata.rate ? rawdata.rate : 0.0;
    this.sign = rawdata.sign ? rawdata.sign : "";
    this.status = rawdata.status ? rawdata.status : "";
    this.updated_at = rawdata.updated_at ? rawdata.updated_at : "";
    this.created_at = rawdata.created_at ? rawdata.created_at : "";
  }

  static async create(payload) {
    var obj = {
      name: payload.name,
      rate: payload.rate,
      sign: payload.sign
    };
    const result = await api.post("/api/v1/suppliers/create_currency/", obj);
    if (result && result.status == 200) return result.data;

    return null;
  }

  static async fetch(id) {
    const result = await api.get(`/api/v1/suppliers/get_currency/${id}/`);
    if (result && result.status == 200) return result.data.data[0];

    return null;
  }

  static async put(payload) {
    const result = await api.put(
      `/api/v1/suppliers/update_currency/${payload.id}/`,
      payload
    );
    if (result && result.status == 200) return result.data;

    return null;
  }

  static async delete(payload) {
    const result = await api.put(
      `/api/v1/suppliers/delete_currency/${payload}/`
    );
    if (result && result.status == 200) return result.data;

    return null;
  }

  // static async getForex(currency_id) {
  //   const result = await api.get(
  //     `api/v1/suppliers/get_currency/${currency_id}`
  //   );
  //   if (result && result.status == 200) return result.data;

  //   return null;
  // }

  static async glossary() {
    const result = await api.get("/api/v1/suppliers/view_currency/", {
      limit: 9999999
    });
    if (result && result.status == 200) {
      return result.data;
    }
    return null;
  }

  static rules() {
    return {
      name: [
        {
          required: true,
          message: "Currency name is required.",
          trigger: "blur"
        }
      ],
      rate: [
        { required: true, message: "Rate is required.", trigger: "blur" },
        {
          type: "number",
          message: "Rate should be a number",
          trigger: "blur"
        }
      ],
      sign: [
        {
          required: true,
          message: "Currency sign is required.",
          trigger: "blur"
        }
      ]
    };
  }
}
